import { requestWrapper } from 'e-submission/domain/data'

export const saveAIUWRequest = (user, payload) => {
  return requestWrapper.postRequest(`esub/ai-uw/${payload.policyId}`, user, payload).then(({ data }) => data)
}

export const getAIUWStatus = (user, payload) => {
  return requestWrapper.getRequest(`esub/ai-uw/status?policyId=${payload.policyId}`, user).then(({ data }) => data)
}
